module.exports = __webpack_public_path__ + "static/media/spacex2.795884ad.png";